import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ExpandScreenIconWhite from '../../../public/assets/images/theme-2/icons/panel-header/fullscreen-white.svg';
import CollapseScreenIconWhite from '../../../public/assets/images/theme-2/icons/panel-header/collapse-white.svg';
import CloseIconWhite from '../../../public/assets/images/theme-2/close-white.svg';

import {
  LoopHeaderSection,
  EditorWrapper,
  Categories,
  Category,
  FieldSet,
  LinkButton,
  Table,
  Row,
  Cell1,
  Cell2,
  Hidden,
} from './styles';
import { HeaderTools, FullScreenHeaderTool, CloseHeaderTool } from '../NodeContentHeaderTools/styles';

const HeaderSection = ({ data, translations, loopSettings, hideDescription }) => {
  const { hasCategories, categories, hasDocumentTags } = loopSettings;

  const [isFullScreen, setIsFullScreen] = useState(document.querySelector('.lp--fullScreenPanel'));
  const [curriculumPopupIsOpen, setCurriculumPopupIsOpen] = useState(false);

  useEffect(() => {
    document.addEventListener('hideCurriculumPopup', () => setCurriculumPopupIsOpen(false));
    return () => document.removeEventListener('hideCurriculumPopup', setCurriculumPopupIsOpen);
  }, []);

  useEffect(() => {
    if (curriculumPopupIsOpen) {
      document.dispatchEvent(new CustomEvent('viewCurriculumPopup'));
    }
  }, [curriculumPopupIsOpen]);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
    document.querySelector('.content-panel').classList.toggle('lp--fullScreenPanel');
  };

  const categorySorter = (a, b) => {
    const getKey = ({ name, gap_type }) => `${gap_type}_${name}`;
    return getKey(a).localeCompare(getKey(b));
  };

  const mappedCategories = (categories || []).sort(categorySorter).map((category) => {
    const { id, gap_type, name } = category;
    const key = `categories.${gap_type}`;
    const gapType = i18n.__(key).toLowerCase();
    const displayName = `${name} (${gapType}) `;
    return <Category key={id} className={`grade-${gap_type}`} dangerouslySetInnerHTML={{ __html: displayName }} />;
  });

  const isEditorEmpty = (content) => !content || content === '<p><br /></p>';
  const isTeacher = window.viewer.options.teacherInSession;

  return (
    <LoopHeaderSection>
      <FieldSet>
        <HeaderTools>
          <FullScreenHeaderTool
            onClick={toggleFullScreen}
            src={isFullScreen ? CollapseScreenIconWhite : ExpandScreenIconWhite}
            title={translations.app.full_screen}
          />
          <CloseHeaderTool onClick={hideDescription} src={CloseIconWhite} title={translations.app.close} />
        </HeaderTools>
        {!isEditorEmpty(data.description) && (
          <EditorWrapper dangerouslySetInnerHTML={{ __html: data.description }} className="content-section" />
        )}
        {!isEditorEmpty(data.purpose) && isTeacher && (
          <EditorWrapper dangerouslySetInnerHTML={{ __html: data.purpose }} className="italic content-section" />
        )}
        <Table>
          <Row>
            <Cell1>
              {data.durationHours} {translations.viewer.circle_duration_unit}
            </Cell1>
            <Cell2>{translations.viewer.circle_duration_text}</Cell2>
          </Row>
          {(hasDocumentTags || hasCategories) && <Hidden>{i18n.__('terms.categories')}</Hidden>}
          {hasDocumentTags && (
            <Row className="link">
              <Cell1>
                <LinkButton className="curriculum-icon" onClick={() => setCurriculumPopupIsOpen(true)} />
              </Cell1>
              <Cell2>
                <LinkButton onClick={() => setCurriculumPopupIsOpen(true)}>
                  {translations.circle.curriculum.view}
                </LinkButton>
              </Cell2>
            </Row>
          )}
          {hasCategories && (
            <Row>
              <Cell1></Cell1>
              <Cell2>
                <Categories>{mappedCategories}</Categories>
              </Cell2>
            </Row>
          )}
        </Table>
      </FieldSet>
    </LoopHeaderSection>
  );
};

export default HeaderSection;

HeaderSection.propTypes = {
  data: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  loopSettings: PropTypes.object.isRequired,
  hideDescription: PropTypes.func.isRequired,
};
